"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSortOrderToSearchQuery = void 0;
exports.setSortOrderToSearchQuery = function (orderBy, sortBy, searchQuery) {
    searchQuery.sortBy = sortBy;
    searchQuery.orderBy = orderBy;
    return searchQuery;
};
